// extracted by mini-css-extract-plugin
export default {"loginBg":"Login_loginBg__68RAD","cardContainer":"Login_cardContainer__+fJ69","logo":"Login_logo__FepzV","poweredBy":"Login_poweredBy__AuTQN"};